import type { Dayjs } from 'dayjs';

export type ComputeGranularity = 'hour' | 'day';

export const HOUR_IN_SECONDS = 3_600;
export const DAY_IN_SECONDS = 86_400;

export const getComputeGranularity = (
  range: [Dayjs, Dayjs]
): { unit: ComputeGranularity; stepSeconds: number } => {
  const [from, to] = range;
  const hours = to.diff(from, 'hour', true);

  if (hours <= 24) {
    return { unit: 'hour', stepSeconds: HOUR_IN_SECONDS };
  }

  return { unit: 'day', stepSeconds: DAY_IN_SECONDS };
};
